import React from "react";
import CheckoutHeader from "./CheckoutHeader";
import "./CheckoutMinimalLayout.css";

class CheckoutMinimalLayout extends React.Component {
  constructor(props) {
    super(props);
    this.rightInnerRef = React.createRef();
    this.rightPanelRef = React.createRef();
    this.mobileSummaryRef = React.createRef();
    this.isSticky = false;
    this.originalTop = 32;
    // Sticky öncesi pozisyon bilgilerini sakla
    this.stickyData = {
      left: 0,
      width: 0,
      threshold: 0
    };
    // Mobile sticky için state
    this.mobileSticky = {
      isSticky: false,
      threshold: 0,
      originalWidth: 0
    };
  }

  componentDidMount() {
    // Sticky çalışması için body ve html'e class ekle
    document.documentElement.classList.add('checkout-page-html');
    document.body.classList.add('checkout-page');

    // CRITICAL: CSS sticky overflow-x:hidden ile çalışmıyor!
    // CSS spec: visible + non-visible kombinasyonu yasak!
    // Çözüm: JavaScript ile position: fixed kullanarak sticky simüle et
    this.handleScroll = this.handleDesktopScroll.bind(this);
    this.handleResize = this.handleWindowResize.bind(this);

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);

    // İlk pozisyonu hesapla - sayfa yüklendiğinde pozisyonları kaydet
    // setTimeout ile DOM'un tam render olmasını bekle
    setTimeout(() => {
      this.updateStickyPosition();
      this.initializeMobileSticky();
    }, 100);
  }

  initializeMobileSticky() {
    // Mobile sticky için initial pozisyonu hesapla
    if (window.innerWidth > 1024 || !this.mobileSummaryRef.current) return;

    const element = this.mobileSummaryRef.current;
    const rect = element.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;

    // Element'in scroll edilmeden ÖNCEKİ pozisyonu
    this.mobileSticky.threshold = rect.top + scrollY;
    this.mobileSticky.originalWidth = rect.width;
  }

  componentWillUnmount() {
    // Sayfa değiştiğinde class'ları kaldır
    document.documentElement.classList.remove('checkout-page-html');
    document.body.classList.remove('checkout-page');

    // Event listener'ları temizle
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  updateStickyPosition() {
    if (!this.rightInnerRef.current || !this.rightPanelRef.current) return;

    const rightPanel = this.rightPanelRef.current;
    const rightInner = this.rightInnerRef.current;

    // Eğer ekran 1024px'den küçükse (mobile), sticky davranışını devre dışı bırak
    if (window.innerWidth <= 1024) {
      if (this.isSticky) {
        rightInner.style.position = '';
        rightInner.style.top = '';
        rightInner.style.left = '';
        rightInner.style.width = '';
        rightInner.style.marginTop = '';
        this.isSticky = false;
        // Reset sticky data
        this.stickyData = { left: 0, width: 0, threshold: 0 };
      }
      return;
    }

    const scrollY = window.scrollY || window.pageYOffset;

    // ADIM 1: Eğer sticky değilsek ve scroll=0 civarındaysak,
    // pozisyon bilgilerini kaydet (ya da güncelle)
    if (!this.isSticky && scrollY < 10) {
      const rightInnerRect = rightInner.getBoundingClientRect();

      // CRITICAL: rightInner'ın SCROLL ÖNCESİ pozisyonunu kaydet
      // Bu pozisyon sticky olduğunda da AYNI kalmalı
      this.stickyData.left = rightInnerRect.left;
      this.stickyData.width = rightInnerRect.width;

      // CRITICAL FIX: Threshold hesaplama
      // Element şu an viewport'ta rightInnerRect.top pozisyonunda (örn: 64px)
      // Scroll edildiğinde viewport'un 32px altına gelsin istiyoruz
      // Bu demektir ki: scrollY = (rightInnerRect.top - 32) olmalı
      // Yani scroll (64-32)=32px olunca, element viewport'un 32px altına gelir
      this.stickyData.threshold = rightInnerRect.top + scrollY - this.originalTop;
    }

    // ADIM 2: Threshold kontrolü yap ve sticky modunu değiştir
    // Pozisyon bilgileri hesaplanmış olmalı (width > 0)
    // scrollY > threshold (not >=) çünkü scroll=0'da sticky olmamalı
    if (this.stickyData.width > 0 && scrollY > this.stickyData.threshold && !this.isSticky) {
      // Sticky moduna GEÇ
      // CRITICAL: Kaydedilmiş left ve width değerlerini kullan
      // X ekseninde SIFIR kayma olacak!
      // margin-top'u sıfırla çünkü top değeri ile aynı görsel konumu koruyacağız
      rightInner.style.position = 'fixed';
      rightInner.style.top = this.originalTop + 'px';
      rightInner.style.left = this.stickyData.left + 'px';
      rightInner.style.width = this.stickyData.width + 'px';
      rightInner.style.marginTop = '0';
      this.isSticky = true;
    } else if (scrollY <= this.stickyData.threshold && this.isSticky) {
      // Normal moduna DÖN
      rightInner.style.position = '';
      rightInner.style.top = '';
      rightInner.style.left = '';
      rightInner.style.width = '';
      rightInner.style.marginTop = '';
      this.isSticky = false;
    }
  }

  handleWindowResize() {
    // Resize olduğunda pozisyonları yeniden hesapla
    // CRITICAL FIX: Sticky moddayken geçici olarak normal mode'a dön,
    // doğru pozisyonları ölç, sonra tekrar sticky yap

    if (!this.rightInnerRef.current || !this.rightPanelRef.current) return;

    const rightInner = this.rightInnerRef.current;

    // Mobil görünümde (<=1024px) desktop sticky'yi kaldır ve mobile sticky'yi yeniden hesapla
    if (window.innerWidth <= 1024) {
      // Desktop sticky'yi kaldır
      if (this.isSticky) {
        rightInner.style.position = '';
        rightInner.style.top = '';
        rightInner.style.left = '';
        rightInner.style.width = '';
        rightInner.style.marginTop = '';
        this.isSticky = false;
        this.stickyData = { left: 0, width: 0, threshold: 0 };
      }

      // Mobile sticky pozisyonlarını yeniden hesapla
      if (this.mobileSummaryRef.current) {
        const element = this.mobileSummaryRef.current;
        const scrollY = window.scrollY || window.pageYOffset;

        // Eğer sticky moddaysa, geçici olarak kaldır ve yeniden hesapla
        if (this.mobileSticky.isSticky) {
          element.style.position = '';
          element.style.top = '';
          element.style.left = '';
          element.style.right = '';
          element.style.width = '';
          element.style.zIndex = '';

          const rect = element.getBoundingClientRect();
          this.mobileSticky.threshold = rect.top + scrollY;
          this.mobileSticky.originalWidth = rect.width;

          // Tekrar sticky yap
          element.style.position = 'fixed';
          element.style.top = '0';
          element.style.left = '0';
          element.style.right = '0';
          element.style.width = '100%';
          element.style.zIndex = '100';
        } else {
          // Normal modda pozisyonları yeniden hesapla
          const rect = element.getBoundingClientRect();
          this.mobileSticky.threshold = rect.top + scrollY;
          this.mobileSticky.originalWidth = rect.width;
        }
      }
      return;
    }

    // Desktop görünümde pozisyonları yeniden hesapla
    const scrollY = window.scrollY || window.pageYOffset;

    if (this.isSticky) {
      // CRITICAL FIX: Sticky moddayken getBoundingClientRect() yanlış değer döner
      // Çünkü element position:fixed ve eski pozisyonda
      // Çözüm: Geçici olarak normal mode'a dön, doğru pozisyonları ölç, tekrar sticky yap

      // 1. Geçici olarak sticky'yi kaldır
      rightInner.style.position = '';
      rightInner.style.top = '';
      rightInner.style.left = '';
      rightInner.style.width = '';
      rightInner.style.marginTop = '';

      // 2. DOĞRU pozisyonları ölç (artık CSS ile pozisyonlanmış)
      const rightInnerRect = rightInner.getBoundingClientRect();
      this.stickyData.left = rightInnerRect.left;
      this.stickyData.width = rightInnerRect.width;
      this.stickyData.threshold = rightInnerRect.top + scrollY - this.originalTop;

      // 3. Tekrar sticky yap (yeni pozisyonlarla)
      rightInner.style.position = 'fixed';
      rightInner.style.top = this.originalTop + 'px';
      rightInner.style.left = this.stickyData.left + 'px';
      rightInner.style.width = this.stickyData.width + 'px';
      rightInner.style.marginTop = '0';
      // this.isSticky zaten true, değiştirme
    } else {
      // Normal moddayken: pozisyonları sıfırdan hesapla
      const rightInnerRect = rightInner.getBoundingClientRect();
      this.stickyData.left = rightInnerRect.left;
      this.stickyData.width = rightInnerRect.width;
      this.stickyData.threshold = rightInnerRect.top + scrollY - this.originalTop;
    }
  }

  handleDesktopScroll() {
    // Desktop sticky için pozisyon güncelle
    this.updateStickyPosition();

    // Mobile sticky - JavaScript ile handle et
    // CSS position:sticky bazı durumlarda çalışmıyor (width:100vw + negative margin kombinasyonu)
    if (window.innerWidth <= 1024 && this.mobileSummaryRef.current) {
      const element = this.mobileSummaryRef.current;
      const scrollY = window.scrollY || window.pageYOffset;

      // Threshold kontrolü - scroll edildiğinde sticky yap
      if (scrollY > this.mobileSticky.threshold && !this.mobileSticky.isSticky) {
        // Sticky mode'a geç
        element.style.position = 'fixed';
        element.style.top = '0';
        element.style.left = '0';
        element.style.right = '0';
        element.style.width = '100%';
        element.style.zIndex = '100';
        this.mobileSticky.isSticky = true;
        element.classList.add('is-stuck');
      } else if (scrollY <= this.mobileSticky.threshold && this.mobileSticky.isSticky) {
        // Normal mode'a dön
        element.style.position = '';
        element.style.top = '';
        element.style.left = '';
        element.style.right = '';
        element.style.width = '';
        element.style.zIndex = '';
        this.mobileSticky.isSticky = false;
        element.classList.remove('is-stuck');
      }
    }
  }

  render() {
    const { leftPanel, rightPanel, customer, isGuest } = this.props;

    return (
      <div className="checkout-layout">
        <section className="checkout-layout__left">
          <div className="checkout-layout__left-inner">
            {/* Header - Logo ve User Info */}
            <div className="checkout-layout__header">
              <CheckoutHeader customer={customer} isGuest={isGuest} />
            </div>

            {/* Sticky Sipariş Özeti Bar - Mobilde */}
            <div className="checkout-layout__sticky-summary" ref={this.mobileSummaryRef}>{rightPanel}</div>

            {/* Form Content */}
            <div className="checkout-layout__left-content">{leftPanel}</div>
          </div>
        </section>

        {/* Desktop Sipariş Özeti - Sağda */}
        <aside className="checkout-layout__right" ref={this.rightPanelRef}>
          <div className="checkout-layout__right-inner" ref={this.rightInnerRef}>
            <div className="checkout-layout__summary">{rightPanel}</div>
          </div>
        </aside>
      </div>
    );
  }
}

export default CheckoutMinimalLayout;



// WEBPACK FOOTER //
// ./src/components/CheckoutMinimalLayout.js